###
# 团队内的通用交互
###

$ ->
  # 快速回到页面顶部
  windowHeight = 0
  refreshWindowHeight = ->
    windowHeight = $(window).height()
  refreshWindowHeight()
  $(window).on 'resize.backTop', refreshWindowHeight

  $backTop = $('#back-to-top')
  $(document).on 'scroll.backTop', (e) ->
    $backTop.toggleClass 'active', $(document).scrollTop() > windowHeight * 0.6
  .on 'click.backTop', '#back-to-top', ->
    simple.scrollTo
      offset: 0
      duration: 300


  # header 里的下拉菜单
  $(document).on 'click', '.link-member-menu', (e) ->
    $link = $(@)
    simple.popover
      pointTo: $link.find('.avatar')
      content: $('#tpl-header-menu').html()
      position: 'bottom-left'
      offset:
        y: -2
      cls: 'popover-header-menu dropdown-list'

    $memberTeamName = $('.popover-header-menu .header-menu-member h2 small')
    teamName = $('tr-header-team-menu .team-name').text()
    if $memberTeamName.text() != teamName
      $memberTeamName.text(teamName)

  .on 'mouseenter', '.header-menu-item', (e) ->
    $item = $(e.currentTarget)
    $item.addClass('mouseenter')

  .on 'mouseleave', '.header-menu-item', (e) ->
    $item = $(e.currentTarget)
    $item.removeClass('mouseenter')

  # 将所有通知置为已读
  .on 'ajax:success', '#noti-mark-read', (e) ->
    $('#notification-count').removeClass('unread').data('unread-count', 0).find('.num').text('')
    $('.noti-pop-list').empty().hide()
    $('.noti-pop-empty').show()
    $(document).trigger 'mousedown.notipop'
    tower.updateNoticeCount(0)


  # 显示、隐藏通知列表
  $('#notification-count').on 'mousedown', ->
    $pop = $('.noti-pop')

    if $pop.hasClass('on')
      $(document).trigger 'mousedown.notipop'
    else
      $pop.addClass 'on'
      simple.popover.destroyAll()
      $(document).off('.notipop').on 'mousedown.notipop', (e) ->
        if !$(e.target).closest('.noti-pop').length
          $pop.removeClass 'on'
          $(document).off '.notipop'
    return false

  # 如果当前已经处在[加入申请]页面之中,则替换掉当前stack
  if $('#page-join-approval').length > 0
    $('.system-message.join-request .process-message')
      .attr 'data-stack-replace', true

  # 强制在新窗口打开站内链接
  $(document).on 'mouseenter', '.editor-style a', (e) ->
    return  if '_blank' is @target

    internalHosts = [
      ''
      'tower.im'
      'p.tower.im'
      '127.1'
      '127.0.0.1'
      'localhost'
    ]

    return  if -1 < $.inArray(@hostname, internalHosts)
    return  if $(e.target).parents('.toc-wrapper').length
    return  $(@).attr 'target', '_blank'

  # 每隔一分钟更新相对时间
  setInterval ->
    tower.adjustReadableTime()
    tower.updateTrReadableDatetime()
  , 60000
